<script lang="ts">
    import dayjs from 'dayjs';
    import { onMount } from 'svelte';

    import TourAsideForm from '$saga/views/Tour/Aside/TourAsideForm.svelte';
    import { ClosedSales } from '$saga/views/Tour/types';

    export let isTravelAloneAuthorized,
        isClosedSales,
        isEbooking,
        code,
        maxAgeAllowed,
        minAgeAllowed,
        bookingType,
        tourType,
        minPrice,
        originalPrice,
        rebateAmount,
        token,
        csrfToken,
        isBookable,
        visibleDates,
        allTourUrl,
        childrenAges,
        bookingFormAction,
        bookingRequestAction,
        tourDuration,
        minPricePerDays,
        dict;

    // FIT only
    export let closedSales;
    let closedSalesFormatted: ClosedSales;

    onMount(() => {
        closedSalesFormatted = JSON.parse(closedSales);
        closedSalesFormatted = closedSalesFormatted.map((closedSale: any) => {
            return {
                startDate: dayjs(closedSale.startDate),
                endDate: dayjs(closedSale.endDate),
            };
        });
    });
</script>

<TourAsideForm
    tourConfig={{
        isTravelAloneAuthorized,
        isClosedSales,
        isEbooking,
        code,
        maxAgeAllowed,
        minAgeAllowed,
        bookingType,
        tourType,
        minPrice,
        originalPrice,
        rebateAmount,
        token,
        csrfToken,
        isBookable,
        visibleDates,
        allTourUrl,
        childrenAges,
        bookingFormAction,
        bookingRequestAction,
        tourDuration,
        minPricePerDays,
        closedSales: closedSalesFormatted,
        dict,
    }}
/>
